import template from './name-and-year-commercial.jade';
import validation from '../../../../services/validation';

export default angular
    .module('cian.addForm.helperNameAndYearCommercial', [])
    .directive('cianAfHelperNameAndYearCommercial', () => ({
        scope: {},
        bindToController: {
            ad: '=',
            form: '=',
            disableTypeahead: '@?',
        },
        controller: ['categoryService', 'jkService', 'bsCenterService', 'addFormLayoutService', 'addressService', 'deviceService', function (categoryService, jkService, bsCenterService, addFormLayoutService, addressService, deviceService) {
            this.isMobile = deviceService.isMobile;

            const currentYear = new Date().getFullYear();
            this.yearMin = currentYear - 250;
            this.yearMax = currentYear + 250;

            this.getBSByTerms = term => {
                if (bsCenterService.isBSCategory(this.ad.category) && addressService.locationId && term && term.trim().length > 2) {
                    return bsCenterService.suggest(term, addressService.locationId, 'location');
                }
            };

            this.onCustomInput = () => {
                // CSSSR-9607
                // bsCenterService.detachBSCenter();
            };

            // при выборе БЦ заполняем форму его данными
            this.onSelectBS = ($item) => {
                bsCenterService.fillBSCenterData($item);
                addressService.setAddress($item.geo.fullAddress, false);
            };

            this.validation = validation(this.form, 'building.buildYear', {
                parse: 'Введите число',
                min: `Укажите год позднее ${this.yearMin}`,
                max: `Укажите год ранее ${this.yearMax}`,
            });

            this.isYearEnabled = () => {
                const { objectType } = categoryService.getInfoByCategory(this.ad.category);
                return objectType != 'shoppingArea';
            };

            const isTypeaheadEnabled = () => {
                const { objectType } = categoryService.getInfoByCategory(this.ad.category);
                return !this.disableTypeahead && (objectType != 'shoppingArea' || this.ad.placementType == 'streetRetail');
            };

        }],
        controllerAs: 'nameAndYearCommercial',
        template,
    }))
    .name;
